module.exports = __webpack_public_path__ + "img/principles-small-logo.f7ed59a7.svg";